<template>
  <section class="relative bg-black overflow-hidden min-h-[85vh] lg:min-h-[calc(100vh-80px)] flex flex-col">
    <img
      :src="heroBgUrl"
      alt=""
      aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover"
    />
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: linear-gradient(101.82deg, rgb(17 17 17) 18.85%, rgba(17,17,17,0.067) 79.34%);"
    />
    <div class="absolute inset-0 backdrop-blur-[7px] bg-black/15 pointer-events-none" />

    <div class="relative flex-1 flex flex-col justify-center gap-12 md:gap-[68px] px-6 lg:px-16 xl:px-40 py-16 md:py-24">
      <div class="flex flex-col gap-6 max-w-[1050px]">
        <h1 class="font-display font-semibold text-4xl md:text-7xl leading-tight !mt-0 !mb-0">
          <span class="text-white">{{ t('home.heroTitleLead') }}</span>
          <br>
          <span class="text-accent-soft">{{ t('home.heroTitleAccent') }}</span>
        </h1>
        <p class="font-sans text-lg md:text-2xl text-white max-w-[790px] !mt-0 !mb-0">
          {{ t('home.heroBody') }}
        </p>
      </div>
      <div class="flex flex-wrap gap-4 items-center">
        <RouterLink
          :to="{ name: 'bookMeeting' }"
          class="inline-flex items-center gap-4 rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
        >
          <span>{{ t('home.bookCall') }}</span>
          <VaIcon name="call" :size="24" />
        </RouterLink>
        <RouterLink
          :to="{ name: 'cases' }"
          class="inline-flex items-center gap-4 rounded bg-surface-1 hover:bg-surface-2 text-white hover:text-white text-[18px] px-4 py-2.5 transition-colors"
        >
          <span>{{ t('home.viewCases') }}</span>
          <VaIcon name="menu_book" :size="24" />
        </RouterLink>
      </div>
    </div>

    <div class="relative w-full h-px bg-white/30" />
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'
import heroBgUrl from '@/assets/images/hero-bg.webp?url'

const { t } = useI18n()
</script>
